import styles from './form.module.scss';

export default function FormButtonList(props: React.PropsWithChildren<unknown>) {
  return <div className={styles.btn_list}>{props.children}</div>;
}
